const sendBtn = document.getElementById('nextCalculator__submit'),
    inputFields = document.getElementsByClassName('nextCalculator__input'),
    responseField = document.getElementById('nextCalculator__response');

const geoEncode = {
    baseURL: "https://maps.googleapis.com/maps/api/geocode/json?",
    KEY: "&key=AIzaSyBzJTGTRbTlNUWqGoJCdQhcShYVK13Oyb8"
}

const getFieldData = () => {

    let fieldData = "address=";

    for (let i = 0; i < inputFields.length; i++) {
        if (i > 0) {
            fieldData += '+' + inputFields[i].value;
        } else {
            fieldData += inputFields[i].value;
        }
    }

    return fieldData;
}

const getDistance = (location) => {
    const nextLocation = {
        lat: 51.686722,
        lon: 5.299351
    }

    let distance = getDistanceFromLatLonInKm(nextLocation.lat, nextLocation.lon, location.lat, location.lon);
    console.log(distance.toFixed(2));

    setToTrue(distance);

}

sendBtn.addEventListener('click', (e) => {
    e.preventDefault();

    fetch(geoEncode.baseURL + getFieldData() + geoEncode.KEY)
        .then((response) => {
            return response.json();
        })

        .then((data) => {

            console.log(data);

            if (setResponse(data.status)) {

                const location = {
                    lat: data.results[0].geometry.location.lat,
                    lon: data.results[0].geometry.location.lng
                }

                getDistance(location);

            }

        });

})

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

function deg2rad(deg) {
    return deg * (Math.PI / 180)
}

function setResponse(status) {
    switch (status) {
        case 'OK' :
            return true;
        case 'ZERO_RESULTS' :
            setToFalse();
            return false;
    }
}

function setToTrue(distance) {
    if (distance <= 20){
        responseField.dataset.state = true;
        responseField.innerHTML = "NEXT mag deze woning taxeren.";
    } else {
        responseField.dataset.state = false;
        responseField.innerHTML = "NEXT mag jammer genoeg deze woning niet taxeren.";
    }

    responseField.innerHTML += "<br>De afstand tussen het te taxeren object en NEXT is ongeveer " + distance.toFixed(2) + " KM";
}

function setToFalse() {
    responseField.dataset.state = false
    responseField.innerHTML = "Adres niet gevonden";
}